import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_images_table = _resolveComponent("images-table")!
  const _component_base_table_panel = _resolveComponent("base-table-panel")!

  return (_openBlock(), _createBlock(_component_base_table_panel, {
    id: "image-panel",
    loading: _ctx.loading,
    onPaginate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('paginate')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_images_table, {
        onDelete: _cache[0] || (_cache[0] = (image) => _ctx.$emit('deleteImage', image))
      })
    ]),
    _: 1
  }, 8, ["loading"]))
}